import { StyledNoAssessments } from './DpNoAssessments.styled';
import { useTranslation } from 'react-i18next';
import image from './assets/smiley-illustration.svg';
import { CurriculumId, getCurriculumPrefixFromCurriculum } from '@greatmindsorg/assess-web-core-lib';
import Image from 'next/image';
interface IProps {
  isEurekaMath: boolean;
}
export const DpNoAssessments = ({
  isEurekaMath
}: IProps) => {
  const {
    t
  } = useTranslation();
  const curriculum = isEurekaMath ? CurriculumId.EurekaMath : CurriculumId.WitAndWisdom;
  return <StyledNoAssessments curriculum={getCurriculumPrefixFromCurriculum(curriculum)}>
      <Image src={image} alt={t('home.home.noAssessments.altImage')} height={224} width={228} />
      <div className="text main">{t('home.home.noAssessments.mainText')}</div>
      <div className="text sub">{t('home.home.noAssessments.subText')}</div>
    </StyledNoAssessments>;
};
export default DpNoAssessments;